import { useEffect, useState } from "react";
import axios from "axios";
import "./Products.css";
import { useNavigate } from "react-router-dom";

const categories = [
  "10/25G",
  "100G",
  "400G",
  "Modular",
  "NVIDIA",
  "Accessories"
];

export default function Products() {
  const [activeCategory, setActiveCategory] = useState("10/25G");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // 🔹 FETCH PRODUCTS
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get("http://localhost:5000/api/products");

        if (Array.isArray(res.data)) {
          setProducts(res.data);
        } else if (Array.isArray(res.data?.products)) {
          setProducts(res.data.products);
        } else {
          setProducts([]);
        }
      } catch (err) {
        console.error("API error:", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // 🔹 ADD TO CART
 const addToCart = (product) => {
  let cart = JSON.parse(localStorage.getItem("cart")) || [];

  const productId = String(product._id);

  const exists = cart.find(
    (item) => String(item._id) === productId
  );

  if (!exists) {
    cart.push({
      _id: productId,
      title: product.title,
      price: Number(product.price),
      image: product.image || "",
      qty: 1
    });

    localStorage.setItem("cart", JSON.stringify(cart));
  }

  navigate("/cart");
};



  // ✅ FIXED FILTER (ONLY LOGIC CHANGE)
  const filteredProducts = products.filter(
    (p) => p.category === activeCategory
  );

  return (
    <section className="nx-section">
      <div className="container">
        <h2 className="nx-heading">
          {activeCategory} Data Center Products
        </h2>

        {/* CATEGORY */}
        <div className="nx-category">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`nx-cat-btn ${
                activeCategory === cat ? "active" : ""
              }`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {loading && <p style={{ padding: 20 }}>Loading products...</p>}

        {!loading && (
          <div className="nx-grid">
            {filteredProducts.length === 0 ? (
              <p style={{ padding: 20 }}>No products found</p>
            ) : (
              filteredProducts.map((item) => (
                <div key={item._id} className="nx-card">
                  <span className="nx-hot">Hot</span>

                  <img
                    src={
                      item.image ||
                      "https://via.placeholder.com/300x200?text=No+Image"
                    }
                    alt={item.title}
                    onError={(e) =>
                      (e.target.src =
                        "https://via.placeholder.com/300x200?text=No+Image")
                    }
                  />

                  <h4>{item.title}</h4>

                  <p className="nx-spec">
                    {item.description?.slice(0, 70)}...
                  </p>

                  <div className="nx-price">
                    ₹{Number(item.price).toLocaleString()}
                  </div>

                  <div className="nx-stock">
                    {item.stock > 0
                      ? `${item.stock} in Stock`
                      : "Out of Stock"}
                  </div>

                  <button
                    className="nx-cart"
                    disabled={item.stock <= 0}
                    onClick={() => addToCart(item)}
                  >
                    Add to Cart
                  </button>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </section>
  );
}
